import { render, staticRenderFns } from "./AgendaSlotComponent.vue?vue&type=template&id=809b69d4&scoped=true"
import script from "./AgendaSlotComponent.vue?vue&type=script&lang=js"
export * from "./AgendaSlotComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaSlotComponent.vue?vue&type=style&index=0&id=809b69d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809b69d4",
  null
  
)

export default component.exports